import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import moment from 'moment-timezone';
import { FilterContainerComponent } from '../filter-container/filter-container.component';
import { Moment } from 'moment';

@Component({
    selector: 'report-filter-as-of-date',
    templateUrl: './as-of-date.component.html',
    styleUrls: ['./as-of-date.component.scss'],
})
export class AsOfDateComponent implements OnInit, AfterViewInit, OnDestroy
{
    @Input()
    public filters: {
        asOfDate: Moment;
    } = null;

    @Input()
    public container: FilterContainerComponent;

    constructor() {
    }

    ngOnInit() {
        this.container.register(this);

        this.filters = {
            asOfDate: moment(),
        };
    }

    ngAfterViewInit() {
        this.container.notifyReady(this);
    }

    public ngOnDestroy(): void {
        // intentionally left blank for subscription cleanup
    }
}
